/* Robomate Domestic — robot mower finder (filters, right-size logic, detailed view, compare, share links). */
(function () {
  'use strict';
 
  var MAX_COMPARE = 3;
  var ZONE_LABELS = { '1': '1 lawn area', '5': '2–5 lawn areas', '10': '6–10 lawn areas', '20': '10+ lawn areas' };
  var LABELS = {
    slope: { flat: 'Flat', rolling: 'Rolling slopes', steep: 'Steep' },
    ground: { typical: 'Typical Kiwi property', muddy: 'Very muddy' },
    trees: { open: 'Open or a few trees', thick: 'Thick tree cover' }
  };
 
  function fmt(n) { return Number(n).toLocaleString('en-NZ'); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // "38.6° incline (80% slope)", "80% (38.6°)", "45" -> 80 / 80 / 45
  function parsePct(t) {
    if (!t) return null;
    var m = String(t).match(/(\d+(?:\.\d+)?)\s*%/);
    if (m) return parseFloat(m[1]);
    var n = parseFloat(t);
    return isNaN(n) ? null : n;
  }
  function driveOf(t) {
    var s = String(t || '').toLowerCase();
    if (!s) return '';
    if (/track/.test(s)) return 'Tracked';
    if (/awd|all.?wheel|4\s*-?\s*wheel|4wd|four/.test(s)) return 'AWD';
    if (/2\s*-?\s*wheel|2wd|two/.test(s)) return '2WD';
    return t;
  }
  function store(key, val) {
    try { if (val === undefined) return window.localStorage.getItem(key); window.localStorage.setItem(key, val); } catch (e) { return null; }
  }
 
  function init(root) {
    if (root.dataset.rmdReady) return;
    root.dataset.rmdReady = '1';
 
    var grid = root.querySelector('[data-grid]');
    var rolling = parseFloat(root.dataset.rolling) || 45;
    var steep = parseFloat(root.dataset.steep) || 70;
    var lawnInput = root.querySelector('[data-lawn]');
    var countEl = root.querySelector('[data-count]');
    var toggleCount = root.querySelector('[data-toggle-count]');
    var activeEl = root.querySelector('[data-active]');
    var emptyEl = root.querySelector('[data-empty]');
    var sortEl = root.querySelector('[data-sort]');
    var tray = root.querySelector('[data-tray]');
    var cmp = root.querySelector('[data-cmp]');
    var side = root.querySelector('.rmd-finder__side');
    var toggleBtn = root.querySelector('[data-filter-toggle]');
 
    var items = Array.prototype.map.call(root.querySelectorAll('[data-card]'), function (el, i) {
      var d = el.dataset;
      var p = {
        el: el, index: i, id: d.id, name: d.name, url: d.url, img: d.img,
        price: parseInt(d.price, 10) || 0, priceText: d.priceText,
        area: d.area ? parseInt(d.area, 10) : null,
        slope: parsePct(d.slope),
        drive: driveOf(d.drive),
        nav: (d.nav || '').trim(),
        lidar: /lidar/i.test(d.nav || ''),
        zones: d.zones ? parseInt(d.zones, 10) : null,
        best: d.best || ''
      };
      var set = function (k, v) { var n = el.querySelector('[data-spec="' + k + '"]'); if (n) n.textContent = v; };
      set('area', p.area ? fmt(p.area) + ' m²' : '—');
      set('slope', p.slope != null ? p.slope + '%' : '—');
      set('drive', p.drive || '—');
      set('nav', p.nav || '—');
      set('zones', p.zones ? 'Up to ' + p.zones : '—');
      var tag = el.querySelector('[data-area-tag]');
      if (tag && p.area) tag.textContent = 'Up to ' + fmt(p.area) + ' m²';
      var sum = el.querySelector('[data-summary]');
      if (sum) sum.textContent = [p.drive, p.slope != null ? p.slope + '% slopes' : '', p.lidar ? 'LiDAR' : ''].filter(Boolean).join(' · ');
      return p;
    });
    var total = items.length;
 
    var state = { lawn: 0, slope: null, ground: null, trees: null, zones: null, sort: 'fit', compare: [], showCompare: false };
 
    // Read filters from the page address (shareable links)
    var q = new URLSearchParams(window.location.search);
    if (q.get('lawn')) state.lawn = parseInt(q.get('lawn'), 10) || 0;
    ['slope', 'ground', 'trees'].forEach(function (k) { if (q.get(k) && LABELS[k][q.get(k)]) state[k] = q.get(k); });
    if (q.get('zones') && ZONE_LABELS[q.get('zones')]) state.zones = q.get('zones');
    if (q.get('sort')) state.sort = q.get('sort');
    if (state.lawn) lawnInput.value = state.lawn;
    if (sortEl) sortEl.value = state.sort;
 
    setView(store('rmdMowerView') || 'overview');
 
    function setView(v) {
      root.classList.toggle('rmd-finder--detailed', v === 'detailed');
      root.querySelectorAll('[data-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.view === v ? 'true' : 'false'); });
    }
 
    function activeList() {
      var a = [];
      if (state.lawn) a.push({ key: 'lawn', label: 'Lawn ' + fmt(state.lawn) + ' m²' });
      ['slope', 'ground', 'trees'].forEach(function (k) { if (state[k]) a.push({ key: k, label: LABELS[k][state[k]] }); });
      if (state.zones) a.push({ key: 'zones', label: ZONE_LABELS[state.zones] });
      return a;
    }
 
    function shareUrl() {
      var u = new URL(window.location.href);
      ['lawn', 'slope', 'ground', 'trees', 'zones', 'sort', 'page'].forEach(function (k) { u.searchParams.delete(k); });
      if (state.lawn) u.searchParams.set('lawn', state.lawn);
      ['slope', 'ground', 'trees', 'zones'].forEach(function (k) { if (state[k]) u.searchParams.set(k, state[k]); });
      if (state.sort !== 'fit') u.searchParams.set('sort', state.sort);
      return u.toString();
    }
 
    function apply() {
      var minSlope = state.slope === 'steep' ? steep : state.slope === 'rolling' ? rolling : 0;
      var minZones = state.zones ? parseInt(state.zones, 10) : 0;
 
      var matches = items.filter(function (p) {
        if (state.lawn && (p.area == null || p.area < state.lawn)) return false;
        if (minSlope && (p.slope == null || p.slope < minSlope)) return false;
        if (state.ground === 'muddy' && (p.drive === '2WD' || !p.drive)) return false;
        if (state.trees === 'thick' && !p.lidar) return false;
        if (minZones && (p.zones == null || p.zones < minZones)) return false;
        return true;
      });
 
      // Right-size: keep only the smallest mapping area that covers the lawn (ties all show)
      if (state.lawn && matches.length) {
        var minArea = Math.min.apply(null, matches.map(function (p) { return p.area; }));
        matches = matches.filter(function (p) { return p.area === minArea; });
      }
 
      var sorters = {
        fit: function (a, b) { return (a.area || 9e9) - (b.area || 9e9) || a.price - b.price; },
        low: function (a, b) { return a.price - b.price; },
        high: function (a, b) { return b.price - a.price; },
        area: function (a, b) { return (b.area || 0) - (a.area || 0); }
      };
      matches.sort(sorters[state.sort] || sorters.fit);
 
      items.forEach(function (p) { p.el.hidden = matches.indexOf(p) < 0; });
      matches.forEach(function (p) { grid.appendChild(p.el); });
 
      var act = activeList();
      var countText = act.length ? matches.length + ' of ' + total + ' mowers suit your property' : 'All ' + total + ' robot mowers';
      countEl.textContent = countText;
      if (toggleCount) toggleCount.textContent = act.length ? matches.length + ' of ' + total + ' mowers' : 'All mowers';
      emptyEl.hidden = matches.length > 0;
      grid.hidden = matches.length === 0;
 
      activeEl.innerHTML = act.map(function (a) {
        return '<button type="button" data-clear="' + a.key + '" aria-label="Remove filter ' + esc(a.label) + '">' + esc(a.label) + ' <span aria-hidden="true">×</span></button>';
      }).join('');
 
      root.querySelectorAll('[data-filter]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(state[b.dataset.filter]) === b.dataset.value ? 'true' : 'false');
      });
      root.querySelectorAll('[data-reset]').forEach(function (b) { b.classList.toggle('is-active', act.length > 0); });
 
      // Share box + address bar
      var url = shareUrl();
      try { window.history.replaceState(null, '', url); } catch (e) {}
      var shortEl = root.querySelector('[data-share-url]');
      if (shortEl) shortEl.textContent = url.replace(/^https?:\/\/(www\.)?/, '');
      var subject = root.dataset.shareSubject || 'Robot mowers';
      var mail = root.querySelector('[data-share-mail]');
      if (mail) mail.href = 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent('Have a look at these: ' + url);
      var sms = root.querySelector('[data-share-sms]');
      if (sms) sms.href = 'sms:?&body=' + encodeURIComponent(subject + ': ' + url);
 
      renderCompare();
    }
 
    function renderCompare() {
      var chosen = state.compare.map(function (id) { return items.filter(function (p) { return p.id === id; })[0]; }).filter(Boolean);
      root.querySelectorAll('[data-compare]').forEach(function (cb) {
        var on = state.compare.indexOf(cb.value) >= 0;
        cb.checked = on;
        cb.disabled = !on && state.compare.length >= MAX_COMPARE;
      });
      tray.hidden = chosen.length === 0 || state.showCompare;
      root.querySelector('[data-tray-count]').textContent = 'Compare ' + chosen.length + ' of ' + MAX_COMPARE;
      root.querySelector('[data-tray-names]').textContent = '· ' + chosen.map(function (p) { return p.name.replace(/^mammotion\s+/i, ''); }).join(', ');
      root.querySelector('[data-cmp-open]').disabled = chosen.length < 2;
 
      var show = state.showCompare && chosen.length >= 2;
      cmp.hidden = !show;
      if (!show) return;
      var rows = [
        ['Price', function (p) { return esc(p.priceText); }],
        ['Max lawn size', function (p) { return p.area ? fmt(p.area) + ' m²' : '—'; }],
        ['Max slope', function (p) { return p.slope != null ? p.slope + '%' : '—'; }],
        ['Drive', function (p) { return esc(p.drive || '—'); }],
        ['Navigation', function (p) { return esc(p.nav || '—'); }],
        ['Lawn zones', function (p) { return p.zones ? 'Up to ' + p.zones : '—'; }],
        ['Best for', function (p) { return esc(p.best || '—'); }]
      ];
      var html = '<table><thead><tr><th scope="col"></th>' + chosen.map(function (p) {
        return '<th scope="col"><div class="rmd-cmp__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + '</div><span class="rmd-cmp__name">' + esc(p.name) + '</span></th>';
      }).join('') + '</tr></thead><tbody>';
      rows.forEach(function (r) {
        html += '<tr><th scope="row">' + r[0] + '</th>' + chosen.map(function (p) { return '<td>' + r[1](p) + '</td>'; }).join('') + '</tr>';
      });
      html += '<tr><th scope="row"></th>' + chosen.map(function (p) {
        return '<td><a class="rmd-btn rmd-btn--yellow" style="min-height:44px;font-size:15px;padding:0 18px;" href="' + esc(p.url) + '">View mower</a></td>';
      }).join('') + '</tr></tbody></table>';
      root.querySelector('[data-cmp-body]').innerHTML = html;
    }
 
    // Events
    var lawnTimer;
    lawnInput.addEventListener('input', function () {
      clearTimeout(lawnTimer);
      lawnTimer = setTimeout(function () { state.lawn = parseInt(lawnInput.value, 10) || 0; apply(); }, 250);
    });
    root.querySelectorAll('[data-filter]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.filter, v = b.dataset.value;
        state[k] = String(state[k]) === v ? null : v;
        apply();
      });
    });
    activeEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-clear]');
      if (!b) return;
      var k = b.dataset.clear;
      if (k === 'lawn') { state.lawn = 0; lawnInput.value = ''; } else { state[k] = null; }
      apply();
    });
    root.querySelectorAll('[data-reset]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.lawn = 0; state.slope = state.ground = state.trees = state.zones = null; lawnInput.value = '';
        apply();
      });
    });
    if (sortEl) sortEl.addEventListener('change', function () { state.sort = sortEl.value; apply(); });
    root.querySelectorAll('[data-view]').forEach(function (b) {
      b.addEventListener('click', function () { setView(b.dataset.view); store('rmdMowerView', b.dataset.view); });
    });
    root.querySelectorAll('[data-compare]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var i = state.compare.indexOf(cb.value);
        if (cb.checked && i < 0 && state.compare.length < MAX_COMPARE) state.compare.push(cb.value);
        if (!cb.checked && i >= 0) state.compare.splice(i, 1);
        if (state.compare.length < 2) state.showCompare = false;
        renderCompare();
      });
    });
    root.querySelector('[data-cmp-open]').addEventListener('click', function () {
      state.showCompare = true; renderCompare();
      cmp.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    root.querySelector('[data-cmp-close]').addEventListener('click', function () { state.showCompare = false; renderCompare(); });
    root.querySelector('[data-cmp-clear]').addEventListener('click', function () { state.compare = []; state.showCompare = false; renderCompare(); });
 
    var copyBtn = root.querySelector('[data-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var url = shareUrl();
      var done = function () {
        copyBtn.textContent = '✓ Copied'; copyBtn.classList.add('is-done');
        setTimeout(function () { copyBtn.textContent = 'Copy link'; copyBtn.classList.remove('is-done'); }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link:', url); });
      } else { window.prompt('Copy this link:', url); }
    });
 
    if (toggleBtn) toggleBtn.addEventListener('click', function () {
      var open = side.classList.toggle('is-open');
      toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
 
    apply();
  }
 
  function boot() { document.querySelectorAll('[data-rmd-finder]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
 